import TextField from "@/components/layouts/History/TextField";
import {
  useLeadInboundCampaignTypes,
  useLeadOutboundCampaignTypes
} from "@/pages/leads/hooks";
import { find } from "lodash";

interface Props {
  value: string;
}

const SourceTypeName: React.FC<Props> = ({ value }) => {
  const inboundCampaignTypes =
    useLeadInboundCampaignTypes().data?.inboundCampaignTypes ?? [];
  const outboundCampaignTypes =
    useLeadOutboundCampaignTypes().data?.outboundCampaignTypes ?? [];

  // Combine both campaign types to search for the value
  const allCampaignTypes = [...inboundCampaignTypes, ...outboundCampaignTypes];

  const campaignType = find(
    allCampaignTypes,
    (type) => type.id === Number(value)
  );
  return <TextField>{campaignType?.name || ""}</TextField>;
};

export default SourceTypeName;
